(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-hanezza-brand-reviews]';
  const TEXT = {
    review: ['değerlendirme yapmak için tıklayın', 'değerlendirme yaz', 'yorum yaz', 'click to review', 'write a review', 'اكتبي تقييمًا', 'كتابة تقييم', 'إضافة تقييم', 'ثبت نظر', 'نوشتن نظر'],
    question: ['bir soru sor', 'soru sor', 'ask a question', 'اطرحي سؤالًا', 'پرسیدن سؤال'],
    response: ['mağaza yanıtladı', 'satıcı yanıtladı', 'store replied', 'merchant reply', 'ردّ المتجر', 'پاسخ فروشگاه']
  };

  const SELECTORS = {
    reviewAction: [
      '[data-action*="review" i]',
      '[data-testid*="review" i]',
      '[class*="write-review" i]',
      '[class*="add-review" i]',
      '[id*="write-review" i]'
    ],
    questionAction: [
      '[data-action*="question" i]',
      '[data-testid*="question" i]',
      '[class*="ask-question" i]',
      '[id*="ask-question" i]'
    ],
    reviewList: [
      '[data-testid*="review-list" i]',
      '[class*="review-list" i]',
      '[class*="reviews-list" i]',
      '[class*="review-content" i]'
    ],
    reviewCard: [
      'article',
      '[data-testid*="review-item" i]',
      '[class*="review-item" i]',
      '[class*="review-card" i]'
    ],
    pagination: [
      'nav[aria-label*="page" i]',
      '[class*="pagination" i]',
      '[data-testid*="pagination" i]'
    ],
    rating: [
      '[data-rating]',
      '[aria-label*="5 üzerinden" i]',
      '[aria-label*="out of 5" i]',
      '[class*="average-rating" i]',
      '[class*="rating-average" i]'
    ],
    count: [
      '[data-review-count]',
      '[class*="review-count" i]',
      '[class*="reviews-count" i]'
    ]
  };

  const norm = (value = '') => String(value).toLocaleLowerCase('tr-TR').replace(/\s+/g, ' ').trim();

  function textMatches(element, needles) {
    const value = norm(element?.textContent || element?.getAttribute?.('aria-label') || '');
    return needles.some((needle) => value.includes(needle));
  }

  function queryFirst(host, selectors) {
    for (const selector of selectors) {
      try {
        const match = host.querySelector(selector);
        if (match) return match;
      } catch (_error) {
        // Ignore selectors unsupported by an older browser.
      }
    }
    return null;
  }

  function findAction(host, selectors, needles) {
    const direct = queryFirst(host, selectors);
    if (direct) return direct;
    return Array.from(host.querySelectorAll('button, a, [role="button"]')).find((element) => textMatches(element, needles)) || null;
  }

  function parseDecimal(value) {
    const parsed = Number.parseFloat(String(value || '').replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
  }

  function parseInteger(value) {
    const parsed = Number.parseInt(String(value || '').replace(/\D/g, ''), 10);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function elementDepth(element, stop) {
    let depth = 0;
    let current = element;
    while (current && current !== stop) {
      depth += 1;
      current = current.parentElement;
    }
    return depth;
  }

  function commonAncestor(elements, stop) {
    const usable = elements.filter(Boolean);
    if (!usable.length) return null;
    let current = usable[0];
    while (current && current !== stop) {
      if (usable.every((element) => current === element || current.contains(element))) return current;
      current = current.parentElement;
    }
    return null;
  }

  function smallestMatches(elements, stop) {
    return elements.filter((element) => {
      return !elements.some((candidate) => candidate !== element && element.contains(candidate) && elementDepth(candidate, stop) > elementDepth(element, stop));
    });
  }

  function findRating(host) {
    for (const selector of SELECTORS.rating) {
      let candidates = [];
      try {
        candidates = Array.from(host.querySelectorAll(selector));
      } catch (_error) {
        continue;
      }
      for (const candidate of candidates) {
        const sources = [candidate.dataset?.rating, candidate.getAttribute('aria-label'), candidate.textContent];
        for (const source of sources) {
          const match = String(source || '').match(/(?:^|\s)([0-5](?:[\.,]\d{1,2})?)\s*(?:\/\s*5|out of 5|5 üzerinden)?(?:\s|$)/i);
          const rating = parseDecimal(match?.[1]);
          if (rating !== null && rating >= 0 && rating <= 5) return rating;
        }
      }
    }
    return null;
  }

  function findReviewCount(host) {
    for (const selector of SELECTORS.count) {
      let candidates = [];
      try {
        candidates = Array.from(host.querySelectorAll(selector));
      } catch (_error) {
        continue;
      }
      for (const candidate of candidates) {
        const dataCount = parseInteger(candidate.dataset?.reviewCount || candidate.getAttribute('data-count'));
        if (dataCount !== null) return dataCount;
        const match = String(candidate.textContent || '').match(/(\d+)\s*(?:değerlendirme|yorum|reviews?)/i);
        const count = parseInteger(match?.[1]);
        if (count !== null) return count;
      }
    }
    return null;
  }

  function markControls(host) {
    const selects = Array.from(host.querySelectorAll('select'));
    selects.forEach((select) => {
      select.classList.add('hanezza-air-control');
      if (select.parentElement && select.parentElement !== host) select.parentElement.classList.add('hanezza-air-control-wrap');
    });

    if (selects.length) {
      const filterbar = commonAncestor(selects, host) || selects[0].parentElement;
      if (filterbar && filterbar !== host) filterbar.classList.add('hanezza-air-filterbar');
    }

    SELECTORS.pagination.forEach((selector) => {
      try {
        host.querySelectorAll(selector).forEach((element) => element.classList.add('hanezza-air-pagination'));
      } catch (_error) {
        // Ignore unsupported selectors.
      }
    });
  }

  function isLikelyReviewCard(element) {
    const value = norm(element.textContent || '');
    if (value.length < 35 || value.length > 4000) return false;
    const hasRating = Boolean(element.querySelector('[aria-label*="star" i], [aria-label*="yıldız" i], [class*="star" i], svg'));
    const hasDate = /\b\d{1,2}[/\.\-]\d{1,2}[/\.\-]\d{2,4}\b/.test(value);
    const hasIdentity = Boolean(element.querySelector('strong, b, h4, h5, [class*="name" i], [class*="author" i]'));
    return (hasRating && hasIdentity) || (hasDate && hasIdentity);
  }

  function findBreakdownPanel(host, cards) {
    const cardSet = new Set(cards);
    const candidates = Array.from(host.querySelectorAll('div, section, aside')).filter((element) => {
      if (cardSet.has(element) || cards.some((card) => card.contains(element) || element.contains(card))) return false;
      const value = norm(element.textContent || '');
      if (!value || value.length > 700) return false;
      const progressCount = element.querySelectorAll('[role="progressbar"], progress, [class*="progress" i], [class*="bar" i]').length;
      const starRows = [1, 2, 3, 4, 5].filter((rating) => new RegExp(`(?:^|\\s)${rating}\\s*[★☆*]`).test(value)).length;
      return progressCount >= 3 || starRows >= 4;
    });
    const smallest = smallestMatches(candidates, host).sort((a, b) => elementDepth(b, host) - elementDepth(a, host));
    return smallest[0] || null;
  }

  function markReviewStructure(host) {
    let list = queryFirst(host, SELECTORS.reviewList);
    const candidates = [];
    SELECTORS.reviewCard.forEach((selector) => {
      try {
        host.querySelectorAll(selector).forEach((element) => candidates.push(element));
      } catch (_error) {
        // Ignore unsupported selectors.
      }
    });

    const cards = Array.from(new Set(candidates)).filter(isLikelyReviewCard);
    cards.forEach((card) => card.classList.add('hanezza-air-review-card'));

    if (!list && cards.length) list = cards[0].parentElement;
    if (list && list !== host) {
      list.classList.add('hanezza-air-review-list');
      const layout = list.parentElement;
      if (layout && layout !== host) layout.classList.add('hanezza-air-review-layout');
    }

    const breakdown = findBreakdownPanel(host, cards);
    if (breakdown) breakdown.classList.add('hanezza-air-breakdown-panel');

    const filterbar = host.querySelector('.hanezza-air-filterbar');
    const shell = commonAncestor([breakdown, filterbar, list].filter(Boolean), host);
    if (shell && shell !== host) shell.classList.add('hanezza-air-review-shell');

    cards.forEach((card) => {
      card.querySelectorAll('div, section, aside').forEach((element) => {
        const value = norm(element.textContent || '');
        if (value.length <= 500 && TEXT.response.some((needle) => value.includes(needle))) {
          element.classList.add('hanezza-air-merchant-response');
        }
      });
      card.querySelectorAll('[aria-label*="star" i], [aria-label*="yıldız" i], [class*="star" i]').forEach((element) => {
        element.classList.add('hanezza-air-rating-star');
      });
    });

    return cards;
  }

  function createChevronIcon() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 20 20');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5 7.5 10 12.5 15 7.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.8');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function ensureMerchantResponseToggle(root, card, index) {
    const responses = Array.from(card.querySelectorAll('.hanezza-air-merchant-response'));
    const response = responses.find((element) => !element.querySelector('.hanezza-air-merchant-response')) || responses[0];
    if (!response) return;

    response.classList.add('is-mobile-collapsed');
    if (!response.id) {
      const productId = String(root.dataset.productId || 'product').replace(/[^a-zA-Z0-9_-]/g, '');
      response.id = `HanezzaReviewResponse-${productId}-${index + 1}`;
    }

    let button = card.querySelector('.hanezza-merchant-response-toggle');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'hanezza-merchant-response-toggle';
      button.setAttribute('aria-expanded', 'false');

      const label = document.createElement('span');
      label.textContent = root.dataset.reviewResponseLabel || 'Hanezza yanıtı';
      button.append(label, createChevronIcon());

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        response.classList.toggle('is-open', !expanded);
      });

      response.insertAdjacentElement('beforebegin', button);
    }

    button.setAttribute('aria-controls', response.id);
    response.classList.toggle('is-open', button.getAttribute('aria-expanded') === 'true');
  }

  function updateReviewListToggle(root, toggle, count) {
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    const showAllTemplate = root.dataset.reviewShowAll || 'Tüm __COUNT__ değerlendirmeyi gör';
    toggle.textContent = expanded
      ? (root.dataset.reviewShowLess || 'Daha az göster')
      : showAllTemplate.replace('__COUNT__', String(count));
  }

  function enhanceReviewExperience(root, host, cards) {
    const list = host.querySelector('.hanezza-air-review-list') || cards[0]?.parentElement || null;
    const expanded = root.querySelector('[data-hanezza-review-list-toggle]')?.getAttribute('aria-expanded') === 'true';

    cards.forEach((card, index) => {
      card.classList.toggle('hanezza-mobile-review-extra', index >= 3);
      card.classList.toggle('is-mobile-expanded', index < 3 || expanded);
      ensureMerchantResponseToggle(root, card, index);
    });

    let toggle = root.querySelector('[data-hanezza-review-list-toggle]');
    if (!list || cards.length <= 3) {
      if (toggle) toggle.hidden = true;
      return;
    }

    if (!list.id) {
      const productId = String(root.dataset.productId || 'product').replace(/[^a-zA-Z0-9_-]/g, '');
      list.id = `HanezzaReviewList-${productId}`;
    }

    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'hanezza-review-list-toggle';
      toggle.dataset.hanezzaReviewListToggle = 'true';
      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', () => {
        const nextExpanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');

        const currentCards = Array.from(host.querySelectorAll('.hanezza-air-review-card'));
        currentCards.forEach((card, index) => {
          if (index >= 3) card.classList.toggle('is-mobile-expanded', nextExpanded);
        });
        updateReviewListToggle(root, toggle, currentCards.length);
      });
    }

    toggle.hidden = false;
    toggle.setAttribute('aria-controls', list.id);
    if (list.nextElementSibling !== toggle) list.insertAdjacentElement('afterend', toggle);
    updateReviewListToggle(root, toggle, cards.length);
  }

  function syncSummary(root, host) {
    const sourceRating = parseDecimal(root.dataset.rating);
    const sourceCount = parseInteger(root.dataset.reviewCount);
    const sourceScale = parseDecimal(root.dataset.ratingScale) || 5;
    const rating = sourceRating !== null && sourceRating > 0 ? sourceRating : findRating(host);
    const count = sourceCount !== null && sourceCount > 0 ? sourceCount : findReviewCount(host);
    const fill = root.querySelector('[data-review-stars-fill]');
    const stars = root.querySelector('[data-review-stars]');
    const ratingText = root.querySelector('[data-review-rating-text]');
    const countText = root.querySelector('[data-review-count-text]');

    if (rating !== null) {
      const normalizedRating = Math.max(0, Math.min(sourceScale, rating));
      const nextFill = `${Math.min(100, (normalizedRating / sourceScale) * 100)}%`;
      if (fill && fill.style.width !== nextFill) fill.style.width = nextFill;
      const nextRatingText = new Intl.NumberFormat(root.dataset.reviewLocale || 'tr-TR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      }).format(normalizedRating);
      if (ratingText) {
        if (ratingText.hidden) ratingText.hidden = false;
        if (ratingText.textContent !== nextRatingText) ratingText.textContent = nextRatingText;
      }
      if (stars) {
        const nextLabel = (root.dataset.reviewStarsTemplate || '__SCALE__ üzerinden __VALUE__ yıldız')
          .replace('__SCALE__', String(sourceScale))
          .replace('__VALUE__', nextRatingText);
        if (stars.getAttribute('aria-label') !== nextLabel) stars.setAttribute('aria-label', nextLabel);
      }
    }

    const hasReviews = (count !== null && count > 0) || (rating !== null && rating > 0);
    if (root.classList.contains('is-review-empty') === hasReviews) {
      root.classList.toggle('is-review-empty', !hasReviews);
    }

    if (count !== null && count > 0 && countText) {
      const nextCountText = (root.dataset.reviewCountTemplate || '__COUNT__ değerlendirme').replace('__COUNT__', String(count));
      if (countText.textContent !== nextCountText) countText.textContent = nextCountText;
    }
  }

  function syncQuestionButton(root, host) {
    const button = root.querySelector('[data-brand-review-action="question"]');
    if (!button) return;
    const target = findAction(host, SELECTORS.questionAction, TEXT.question);
    button.hidden = !target;
    button.setAttribute('aria-hidden', button.hidden ? 'true' : 'false');
  }

  function hasRenderedWidget(host) {
    if (host.querySelector('iframe')) return true;
    if (Array.from(host.querySelectorAll('*')).some((element) => element.shadowRoot)) return true;

    return Array.from(host.querySelectorAll('.hanezza-brand-reviews__app-block *')).some((element) => {
      if (element.matches('input[type="hidden"], script, style, template')) return false;
      if (element.matches('img, video, button, select, textarea, form, article, [role="article"], [role="listitem"]')) return true;
      if (element.children.length > 0) return false;
      return norm(element.textContent).length > 20;
    });
  }

  function integrate(root) {
    const host = root.querySelector('[data-brand-review-widget]');
    if (!host) return;

    root.removeAttribute('hidden');
    root.style.removeProperty('display');
    const rendered = hasRenderedWidget(host);
    root.classList.toggle('is-air-integrated', rendered);
    syncSummary(root, host);
    syncQuestionButton(root, host);

    if (!rendered) {
      root.dataset.widgetMode = 'pending';
      return;
    }

    markControls(host);
    const cards = markReviewStructure(host);
    root.dataset.widgetMode = host.querySelector('iframe') ? 'iframe' : cards.length ? 'dom' : 'widget';
    root.dataset.widgetReady = 'true';
  }

  function bindActions(root) {
    const host = root.querySelector('[data-brand-review-widget]');
    if (!host || root.dataset.hanezzaActionsBound === 'true') return;
    root.dataset.hanezzaActionsBound = 'true';

    root.querySelector('[data-brand-review-action="review"]')?.addEventListener('click', () => {
      const target = findAction(host, SELECTORS.reviewAction, TEXT.review);
      if (target) target.click();
      else host.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    root.querySelector('[data-brand-review-action="question"]')?.addEventListener('click', () => {
      const target = findAction(host, SELECTORS.questionAction, TEXT.question);
      if (target) target.click();
    });
  }

  function mount(root) {
    if (!root) return;
    bindActions(root);
    integrate(root);
    const host = root.querySelector('[data-brand-review-widget]');
    if (!host || host.dataset.hanezzaObserved === 'true') return;
    host.dataset.hanezzaObserved = 'true';

    let frame = 0;
    const observer = new MutationObserver(() => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => integrate(root));
    });
    observer.observe(host, { childList: true, subtree: true });
    root.hanezzaAirObserver = observer;
  }

  function unmount(scope) {
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => {
      root.hanezzaAirObserver?.disconnect();
      delete root.hanezzaAirObserver;
    });
  }

  function boot(scope = document) {
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
})();
